import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-subscription-banner-trial-sole',
  templateUrl: './subscription-banner-trial-sole.component.html',
  styleUrls: ['./subscription-banner-trial-sole.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerTrialSoleComponent {
}
